import config from '../../config/config';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles`, { ...parameters });
  },
  /**
   * Fetch the Accounts list for export
   */
  fetchRolesExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAllRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles/role-names`, {
      ...parameters,
    });
  },
  /**
   * Fetch the permissions list
   */
  fetchAllPermissions: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles/permissions-list`, {});
  },
  /**
   * Create the role api call function
   * @param data
   * @returns
   */
  createRoles: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/facility/v1/roles`, { ...parameters });
  },
  /**
   * Update the role api call function
   * @param data
   * @returns
   */
  editRoles: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/facility/v1/roles/${id}`, {
      ...parameters,
    });
  },

  /**
   * Fetch role API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles/list-filters`);
  },
  /**
   * Get the role by id api call function
   * @param data
   * @returns
   */
  fetchRoleById: (id: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/roles/${id}`);
  },
};
